"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createStringMap() {
    var map = Object.create(null);
    // tslint:disable-next-line:no-string-literal
    delete map['hint'];
    return map;
}
exports.createStringMap = createStringMap;
function createNumberMap() {
    return createStringMap();
}
exports.createNumberMap = createNumberMap;
function hasOwnProperty(collection, key) {
    return Object.prototype.hasOwnProperty.call(collection, key);
}
exports.hasOwnProperty = hasOwnProperty;
function isEmptyMap(map) {
    for (var key in map) {
        if (hasOwnProperty(map, key)) {
            return false;
        }
    }
    return true;
}
exports.isEmptyMap = isEmptyMap;
/**
 * Clones Map collection. Required due to IE11 not supporing `new Map(map)`.
 */
function cloneMap(map) {
    var clone = new Map();
    map.forEach(function (value, key) { return clone.set(key, value); });
    return clone;
}
exports.cloneMap = cloneMap;
/**
 * Clones Set collection. Required due to IE11 not supporing `new Set(set)`.
 */
function cloneSet(set) {
    var clone = new Set();
    set.forEach(function (item) { return clone.add(item); });
    return clone;
}
exports.cloneSet = cloneSet;
var OrderedMap = /** @class */ (function () {
    function OrderedMap() {
        this.mapping = createStringMap();
        this.ordered = [];
    }
    Object.defineProperty(OrderedMap.prototype, "items", {
        get: function () {
            return this.ordered;
        },
        enumerable: true,
        configurable: true
    });
    OrderedMap.prototype.get = function (key) {
        return this.mapping[key];
    };
    OrderedMap.prototype.push = function (key, value) {
        if (key in this.mapping) {
            var previous = this.mapping[key];
            if (previous === value) {
                return;
            }
            var index = this.ordered.indexOf(previous);
            this.ordered.splice(index, 1);
        }
        this.mapping[key] = value;
        this.ordered.push(value);
    };
    OrderedMap.prototype.delete = function (key) {
        if (!(key in this.mapping)) {
            return undefined;
        }
        var previous = this.mapping[key];
        var index = this.ordered.indexOf(previous);
        this.ordered.splice(index, 1);
        delete this.mapping[key];
        return previous;
    };
    return OrderedMap;
}());
exports.OrderedMap = OrderedMap;
var HashMap = /** @class */ (function () {
    function HashMap(hashCode, equals) {
        this.hashCode = hashCode;
        this.equals = equals;
        this.map = new Map();
        this._size = 0;
    }
    Object.defineProperty(HashMap.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    HashMap.prototype.has = function (key) {
        var _this = this;
        var items = this.map.get(this.hashCode(key));
        if (!items) {
            return false;
        }
        return Boolean(items.find(function (p) { return _this.equals(p.key, key); }));
    };
    HashMap.prototype.get = function (key) {
        var _this = this;
        var items = this.map.get(this.hashCode(key));
        if (!items) {
            return undefined;
        }
        var pair = items.find(function (p) { return _this.equals(p.key, key); });
        return pair ? pair.value : undefined;
    };
    HashMap.prototype.set = function (key, value) {
        var _this = this;
        var hash = this.hashCode(key);
        var items = this.map.get(hash);
        if (items) {
            var index = items.findIndex(function (p) { return _this.equals(p.key, key); });
            if (index >= 0) {
                items.splice(index, 1);
            }
            else {
                this._size++;
            }
            items.push({ key: key, value: value });
        }
        else {
            items = [{ key: key, value: value }];
            this.map.set(hash, items);
            this._size++;
        }
        return this;
    };
    HashMap.prototype.delete = function (key) {
        var _this = this;
        var items = this.map.get(this.hashCode(key));
        if (!items) {
            return false;
        }
        var index = items.findIndex(function (p) { return _this.equals(p.key, key); });
        if (index >= 0) {
            items.splice(index, 1);
            this._size--;
            return true;
        }
        else {
            return false;
        }
    };
    HashMap.prototype.clear = function () {
        this.map.clear();
        this._size = 0;
    };
    HashMap.prototype.forEach = function (callback) {
        var _this = this;
        this.map.forEach(function (items) {
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var _a = items_1[_i], key = _a.key, value = _a.value;
                callback(value, key, _this);
            }
        });
    };
    HashMap.prototype.clone = function () {
        var clone = new HashMap(this.hashCode, this.equals);
        clone._size = this.size;
        this.map.forEach(function (value, key) { return clone.map.set(key, value.slice()); });
        return clone;
    };
    return HashMap;
}());
exports.HashMap = HashMap;
